import React from "react";
import { useTranslation} from 'react-i18next';
import { Row, Col } from "react-bootstrap";
import MaterialIcon from "react-google-material-icons";

// Icons matched to why_0..why_2
const WHY_ICONS = ["engineering", "analytics", "science"];
// Icons matched to why2_0..why2_2
const WHY2_ICONS = ["group", "trending_up", "bolt"];

export const About = (props) => {
  const { t } = useTranslation();
  const why = [];
  const why2 = [];

  for (var i=0; i < t("About.count_why"); i++) {
    why.push(t("About.why_"+i));
  }

  for (i=0; i < t("About.count_why2"); i++) {
    why2.push(t("About.why2_"+i));
  }

  return (
    <div id="about">
      <Row>
      <Col xs="12" lg="6">
        <center >
          <img src={t("About.img")} alt="Not found"/>
        </center>
      </Col>
      <Col xs="12" lg="12" xl="6">
          <div className="about-text">
            <h2>{t("About.title")}</h2>
            <p style={{color: "dodgerblue"}}><b>{t("About.paragraphHeader")}</b></p>
            <p>{t("About.paragraph")}</p>
            <h3>{t("About.whywe")}</h3>
            <div className="list-style">
              <div className="col-xl-6 col-lg-12 col-sm-12 col-xs-12">
                <ul>
                  {why.length > 0
                    ? why.map((d, i) => (
                        <li key={`${d}-${i}`} className="about-list-item">
                          <span className="about-list-icon">
                            <MaterialIcon icon={WHY_ICONS[i] || "check"} size={28}/>
                          </span>
                          <span className="about-list-text">{d}</span>
                        </li>
                      ))
                    : "loading"}
                </ul>
              </div>
              <div className="col-xl-6 col-lg-12 col-sm-12 col-xs-12">
                <ul>
                  {why2.length > 0
                    ? why2.map((d, i) => (
                        <li key={`${d}-${i}`} className="about-list-item">
                          <span className="about-list-icon">
                            <MaterialIcon icon={WHY2_ICONS[i] || "check"} size={28}/>
                          </span>
                          <span className="about-list-text">{d}</span>
                        </li>
                      ))
                    : "loading"}
                </ul>
              </div>
            </div>
          </div>
      </Col>
      </Row>
    </div>
  );
};
